import React from 'react'
import PropTypes from 'prop-types'
import {Tag} from '@/components/atoms'
import {SIZE} from '@/utils/constants/globalStyle'
import {Constants} from '@/utils/constants/commonConstants'

export default function GroupsBreadcrumb({groups}) {
  if (!groups || groups.length <= 1) return null
  return (
    <div className="flex flex-wrap items-center gap-3 mb-3" id="groups-breadcrumb" data-testid="groups-breadcrumb">
      {groups.map((g, i) => (
        <React.Fragment key={`crumb-${g.id}`}>
          {i > 0 && (
              <span className="text-sm text-white">{Constants.TextOr}</span>
          )}
          <span id={`groups-breadcrumb-item-${g.id}`} data-testid={`groups-breadcrumb-item-${g.id}`}>
            <Tag text={`Group ${g.id}`} color={'default'} size={SIZE.MEDIUM} />
          </span>
        </React.Fragment>
      ))}
    </div>
  )
}

GroupsBreadcrumb.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      items: PropTypes.array,
    })
  ),
}

